var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import api from "shared/api/axios-instance";
var COLLECTION_TYPES = ["AUCTION", "PAST_AUCTION", "VANISH"];
var toCollectionType = function (type) {
    return COLLECTION_TYPES.includes(type)
        ? type
        : "AUCTION";
};
var BLOCKCHAINS = [
    "bsc",
    "ethereum",
    "polygon",
    "solana",
    "base",
];
var toBlockchain = function (network) {
    var normalized = network === null || network === void 0 ? void 0 : network.toLowerCase();
    return BLOCKCHAINS.includes(normalized)
        ? normalized
        : "bsc";
};
var socialString = function (socials, key) {
    var value = socials === null || socials === void 0 ? void 0 : socials[key];
    return typeof value === "string" && value.length > 0 ? value : null;
};
// Backend → FE model. FE-only fields get sensible defaults so the existing UI
// (which expects the full AdminCollection shape) keeps working unchanged.
var toAdminCollection = function (c) {
    var _a, _b, _c, _d, _e, _f;
    return ({
        id: c.id,
        name: c.name,
        slug: (_a = c.slug) !== null && _a !== void 0 ? _a : "",
        creatorId: (_b = c.creatorId) !== null && _b !== void 0 ? _b : null,
        creatorName: "",
        creatorVerified: false,
        blockchain: toBlockchain(c.network),
        contractAddress: "",
        tokenStandard: "ERC-721",
        mintDate: null,
        totalSupply: null,
        category: (c.category || "residential"),
        verified: c.verified,
        type: toCollectionType(c.type),
        status: "active",
        bannerUrl: c.bannerUrl || null,
        logoUrl: c.logoUrl || null,
        description: c.description,
        aboutBlocks: [],
        website: socialString(c.socials, "sharedLink"),
        twitter: socialString(c.socials, "twitter"),
        discord: socialString(c.socials, "discord"),
        instagram: socialString(c.socials, "instagram"),
        royaltyBps: 0,
        royaltyReceiver: "",
        royaltyPercent: typeof c.royaltyPercent === "number" ? c.royaltyPercent : 0,
        paymentCoinId: (_c = c.paymentCoinId) !== null && _c !== void 0 ? _c : null,
        paymentToken: (_d = c.paymentToken) !== null && _d !== void 0 ? _d : null,
        region: ((_e = c.region) !== null && _e !== void 0 ? _e : null),
        country: (_f = c.country) !== null && _f !== void 0 ? _f : null,
        latitude: typeof c.latitude === "number" ? c.latitude : null,
        longitude: typeof c.longitude === "number" ? c.longitude : null,
        itemCount: typeof c.itemCount === "number" ? c.itemCount : 0,
        createdAt: c.createdAt,
        updatedAt: c.createdAt,
        archivedAt: null,
    });
};
var str = function (fd, key) { var _a; return (_a = fd.get(key)) !== null && _a !== void 0 ? _a : ""; };
var file = function (fd, key) {
    var value = fd.get(key);
    return value instanceof File && value.size > 0 ? value : null;
};
// FE wizard FormData → backend multipart. The backend only accepts
// name/description/network/category/type/verified/socials/logo/banner.
var buildSocials = function (fd) {
    var socials = {};
    var website = str(fd, "website");
    var twitter = str(fd, "twitter");
    var instagram = str(fd, "instagram");
    var discord = str(fd, "discord");
    if (website)
        socials.sharedLink = website;
    if (twitter)
        socials.twitter = twitter;
    if (instagram)
        socials.instagram = instagram;
    if (discord)
        socials.discord = discord;
    return JSON.stringify(socials);
};
var toBackendFormData = function (fd, isCreate) {
    var out = new FormData();
    var name = str(fd, "name");
    if (name)
        out.append("name", name);
    // slug обязателен на бэке при создании; при апдейте — только если задан.
    var slug = str(fd, "slug");
    if (slug)
        out.append("slug", slug);
    out.append("description", str(fd, "description"));
    out.append("network", str(fd, "blockchain") || "BSC");
    out.append("category", str(fd, "category") || "residential");
    // Геолокация: region/country/координаты (пустые не шлём).
    var region = str(fd, "region");
    if (region)
        out.append("region", region);
    var country = str(fd, "country");
    if (country)
        out.append("country", country);
    var latitude = str(fd, "latitude");
    if (latitude)
        out.append("latitude", latitude);
    var longitude = str(fd, "longitude");
    if (longitude)
        out.append("longitude", longitude);
    out.append("type", str(fd, "type") || "AUCTION");
    out.append("verified", str(fd, "verified") === "true" ? "true" : "false");
    out.append("socials", buildSocials(fd));
    // Автор коллекции (uuid) — отправляем, только если выбран валидный пользователь.
    var creatorId = str(fd, "creatorId");
    if (creatorId && creatorId !== "null")
        out.append("creatorId", creatorId);
    // Роялти автора, % (0–10). Пустое поле → 0.
    var royaltyPercent = str(fd, "royaltyPercent");
    out.append("royaltyPercent", royaltyPercent ? royaltyPercent : "0");
    // Токен оплаты коллекции (uuid монеты) — обязателен на бэкенде при создании.
    var paymentCoinId = str(fd, "paymentCoinId");
    if (paymentCoinId)
        out.append("paymentCoinId", paymentCoinId);
    var logo = file(fd, "logo");
    var banner = file(fd, "banner");
    if (logo)
        out.append("logo", logo);
    if (banner)
        out.append("banner", banner);
    return out;
};
export var collectionsAdminApi = {
    getAll: function (filters) { return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.get("/admin/collections", {
                        params: {
                            search: (filters === null || filters === void 0 ? void 0 : filters.search) || undefined,
                            network: (filters === null || filters === void 0 ? void 0 : filters.blockchain) || undefined,
                            category: (filters === null || filters === void 0 ? void 0 : filters.category) || undefined,
                            type: (filters === null || filters === void 0 ? void 0 : filters.type) || undefined,
                            verified: (filters === null || filters === void 0 ? void 0 : filters.verified) === undefined ? undefined : filters.verified,
                            limit: 100,
                        },
                    })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data.data.map(toAdminCollection)];
            }
        });
    }); },
    getPaged: function (filters, page, limit) { return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.get("/admin/collections", {
                        params: {
                            search: (filters === null || filters === void 0 ? void 0 : filters.search) || undefined,
                            network: (filters === null || filters === void 0 ? void 0 : filters.blockchain) || undefined,
                            category: (filters === null || filters === void 0 ? void 0 : filters.category) || undefined,
                            type: (filters === null || filters === void 0 ? void 0 : filters.type) || undefined,
                            verified: (filters === null || filters === void 0 ? void 0 : filters.verified) === undefined ? undefined : filters.verified,
                            page: page,
                            limit: limit,
                        },
                    })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, { data: data.data.map(toAdminCollection), meta: data.meta }];
            }
        });
    }); },
    getById: function (id) { return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.get("/admin/collections/".concat(id))];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, toAdminCollection(data)];
            }
        });
    }); },
    create: function (payload) { return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.post("/admin/collections", toBackendFormData(payload, true))];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, toAdminCollection(data)];
            }
        });
    }); },
    update: function (id, payload) { return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.patch("/admin/collections/".concat(id), toBackendFormData(payload, false))];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, toAdminCollection(data)];
            }
        });
    }); },
    deleteOne: function (id) { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.delete("/admin/collections/".concat(id))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); },
    // Verification toggle — PATCH /admin/collections/:id/verification
    setVerification: function (id, verified) { return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.patch("/admin/collections/".concat(id, "/verification"), { verified: verified })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, toAdminCollection(data)];
            }
        });
    }); },
    // Type switch — PATCH /admin/collections/:id/type. VANISH triggers backend
    // cascade (items delisted + hidden, active offers expired).
    setType: function (id, type) { return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.patch("/admin/collections/".concat(id, "/type"), { type: type })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, toAdminCollection(data)];
            }
        });
    }); },
    // Проверка уникальности slug на бэкенде. excludeId — текущая коллекция при
    // редактировании (её собственный slug считается доступным).
    checkSlug: function (slug, excludeId) { return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.get("/admin/collections/check-slug", { params: { slug: slug, excludeId: excludeId || undefined } })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    }); },
    // Запуск on-chain минта коллекции (деплой ERC-721 + mint всех NFT на hot-wallet).
    // Фоновая задача на бэке; статус смотреть через getMintStatus.
    mint: function (id) { return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.post("/admin/collections/".concat(id, "/mint"))];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    }); },
    getMintStatus: function (id) { return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.get("/admin/collections/".concat(id, "/mint-status"))];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    }); },
};
